/**
 * Woran die App eine „leere“ Aufnahme erkennt (frontend/app.ts, pttSendBlob): Meldungen des Servers, die diesem Muster
 * entsprechen, zeigen den Hinweis ruhig (kein „Erneut senden“, Wartezeit als „leer“, nativen Weg meiden). EINE Quelle für die App,
 * den Rausch-Hinweis des Servers (server/schmied-rauschen.ts, RAUSCH_HINWEIS) und die Tests — ändert sich das Muster oder der Satz,
 * fällt es dort auf (18.10.2026: der Hinweis traf das Muster nicht und zeigte „Verbindung unterbrochen“).
 * ⚠️ „teil-nicht-erkannt“ darf NICHT passen (tests/frontend/diktat-teile-2618.test.ts).
 */
export const PTT_LEER_MUSTER = /nichts gehört|nichts gehoert|nichts verstanden|war leer|\bleer\b|empty|nothing|für rauschen gehalten|fuer rauschen gehalten/i;
